import { createAction } from "redux-actions";
import { ADD_SAVED_PRODUCT, REMOVE_SAVED_PRODUCT } from "./constants";

export const saveProduct = createAction(
  ADD_SAVED_PRODUCT,
  productId => productId
);

export const removeSavedProduct = createAction(
  REMOVE_SAVED_PRODUCT,
  productId => productId
);
